import { type JSX } from 'solid-js'
import type { ViewProps } from 'wdc-cube-solid'
import type { SignInScope } from 'mormaii-web-presentation/auth'

import { AccountFrame, Alert, Field, Heading, PrimaryButton, TextButton } from '../../components/account'

import Css from './account.module.scss'

/** A porta. */
export function SignInView(props: ViewProps<SignInScope>): JSX.Element {
    const submit = (event: Event) => {
        event.preventDefault()
        void props.scope.onSignIn()
    }

    return (
        <AccountFrame>
            <Heading subtitle="Para continuar, informe seus dados:">Entrar</Heading>

            <form class={Css.form} onSubmit={submit}>
                <Alert message={props.scope.error} />

                <Field
                    label="E-mail"
                    type="email"
                    autocomplete="username"
                    value={props.scope.email}
                    onChange={(v) => props.scope.onEmailChanged(v)}
                />

                <Field
                    label="Senha"
                    type="password"
                    autocomplete="current-password"
                    value={props.scope.password}
                    onChange={(v) => props.scope.onPasswordChanged(v)}
                />

                <TextButton class={Css.tucked} onClick={() => void props.scope.onForgotPassword()}>
                    Esqueci minha senha
                </TextButton>

                <PrimaryButton busy={props.scope.busy}>{props.scope.busy ? 'Entrando…' : 'Entrar'}</PrimaryButton>
            </form>
        </AccountFrame>
    )
}
